/* Brunette + Co: open header dropdowns on hover (mouse devices only). Added by Claude 2026-10-15.
   Clicking and keyboard (Enter/Space/Escape) keep working exactly as before. Touch and phone menus are untouched. */
(function () {
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  if (!canHover.matches) return;

  var menus = document.querySelectorAll('.header__inline-menu header-menu');
  if (!menus.length) return;

  var CLOSE_DELAY = 180;

  function setOpen(details, summary, isOpen) {
    if (isOpen) {
      details.setAttribute('open', '');
    } else {
      details.removeAttribute('open');
    }
    summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  var entries = [];
  menus.forEach(function (menu) {
    var details = menu.querySelector('details');
    var summary = details && details.querySelector('summary');
    if (!details || !summary) return;
    var timer = null;
    var entry = { details: details, summary: summary, close: function () { clearTimeout(timer); setOpen(details, summary, false); } };
    entries.push(entry);

    menu.addEventListener('mouseenter', function () {
      clearTimeout(timer);
      entries.forEach(function (other) { if (other !== entry) other.close(); });
      setOpen(details, summary, true);
    });

    menu.addEventListener('mouseleave', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { setOpen(details, summary, false); }, CLOSE_DELAY);
    });

    // A mouse click on an already hover-opened parent should keep it open, not toggle it shut.
    // Keyboard activation reports detail === 0, so it still toggles normally.
    summary.addEventListener('click', function (event) {
      if (event.detail > 0 && details.hasAttribute('open')) {
        event.preventDefault();
      }
    });
  });
})();
